import React from 'react'

/**
 * @typedef {Object} Props
 * @property {boolean} Props.disabled
 * @property {boolean} Props.value - number or an empty string - required for controlled input
 * @property {boolean} Props.defaultValue - initial value when using uncontrolled input
 * @property {(value: String) => void} Props.onChange
 * @property {string} Props.text - label
 * @property {string} Props.id - optional needed for uncontrolled input
 */

/**
 * @param {Props} props
 * @param {React.ForwardedRef<HTMLInputElement>} ref
 */
function NumPicker(props, ref) {
    const {
        onChange,
        value,
        defaultValue,
        disabled,
        min, max,
        text,
        id,
        ...rest
    } = props

    const input = (
        <input
            type="number"
            value={value}
            defaultValue={defaultValue}
            min={min}
            max={max}
            disabled={disabled}
            id={id}
            onChange={e => {
                if (onChange && !disabled) {
                    onChange(e.target.value)
                }
            }}
            ref={ref}
        />
    )

    return <label
            className={value}
            {...rest}
        >
        {input}
        {text !== '' && text ? <span className={"margin-left-sm"}>{text}</span> : null}
    </label>
}

export default React.forwardRef(NumPicker)